import React from "react";
import styled from "styled-components";

export default styled.div`
  color: #ffea9b;
  font-size: 4.8rem;
  margin-bottom: 2rem;
`;
